import { dynamicLoader } from '~/utils';

export const CompanySelector = dynamicLoader({
  name: 'CompanySelector',
  importFunc: () => import('./company-selector'),
});